import API from './API';

type IssueType = {
  name: string;
};

export default {
  async getIssueTypes(projectId: number): Promise<Array<IssueType>> {
    const response = await API.request(
      `/rest/api/3/issuetype/project?projectId=${projectId}`
    );
    return JSON.parse(response.body);
  },
};
